module.exports = __webpack_public_path__ + "static/absence_function-4a9f83e575cb7aad0ddd59101d87b2d9.png";